import {
  fetchText
} from "./chunk-CXYZ37JF.js";
import {
  toError
} from "./chunk-2GHSQBQ5.js";

// src/utils/decode-error.ts
var DecodeError = class _DecodeError extends Error {
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    Object.setPrototypeOf(this, _DecodeError.prototype);
    this.name = "DecodeError";
  }
};

// src/utils/network-error.ts
var NetworkError = class _NetworkError extends Error {
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    Object.setPrototypeOf(this, _NetworkError.prototype);
    this.name = "NetworkError";
  }
};

// src/utils/hls-media-playlist.ts
import { Parser } from "m3u8-parser";
async function loadHlsMediaPlaylist(url, options) {
  let data;
  try {
    data = await fetchText(url, options);
  } catch (e) {
    const error = toError(e);
    if (error.name === "AbortError") {
      throw error;
    }
    throw new NetworkError(`Failed to fetch media playlist: ${url}`, error);
  }
  return parseHlsMediaPlaylist(data);
}
function parseHlsMediaPlaylist(data) {
  const parser = new Parser();
  try {
    parser.push(data);
    parser.end();
  } catch (e) {
    throw new DecodeError("Failed to parse media playlist.", toError(e));
  }
  const manifest = parser.manifest;
  const fixedEnd = manifest.endList === true || manifest.playlistType === "VOD";
  const fixedStart = manifest.playlistType === "VOD" || manifest.playlistType === "EVENT";
  const programDateTime = manifest.dateTimeObject;
  const playlistDuration = manifest.totalDuration ?? manifest.segments.reduce((total, segment) => total + segment.duration, 0);
  const averageSegmentDuration = manifest.segments.length === 0 ? manifest.targetDuration : Math.round(playlistDuration / manifest.segments.length);
  if (averageSegmentDuration === void 0) {
    throw new DecodeError("Media playlist is missing required tag EXT-X-TARGETDURATION.");
  }
  return {
    averageSegmentDuration,
    fixedEnd,
    fixedStart,
    playlistDuration,
    programDateTime
  };
}

export {
  DecodeError,
  NetworkError,
  loadHlsMediaPlaylist
};
